module.exports = __webpack_public_path__ + "static/media/sharing.ca429e0b.png";